module.exports = __webpack_public_path__ + "static/2-74cd5d298cba97cd0d8ed78ce9dac95d.png";